





import {
  Vue,
  Component
} from "@/shared/vuepack";
import IdentityChallenge from "./IdentityChallenge.vue";
import DemographicConfirmation from "./DemographicConfirmation.vue";
import { useContactInfoStore } from "@/shared/store/contactinfo";

@Component({
  components: {
    DemographicConfirmation,
    IdentityChallenge
  }
})
export default class VerifyIdentity extends Vue {
  contactInfoStore = useContactInfoStore();

  onStepComplete (e) {
    this.$emit("complete", e); // pass it up the chain
  }
}
